module.exports = __webpack_public_path__ + "img/prices_bg.202786b5.svg";